import React, { Component } from "react";
import { observer } from "mobx-react";
import { GFunc, GState, LogicX, NavX, RegFunc, ReqX } from "IZOX/STATIC";
import { SysConfig } from "__SYSDefault/Config";
import _ from "lodash";
import { StartUpFunc } from "__SYSDefault/StartUpFunc";
import Viewer from "react-viewer";
import ZSnackBar from "./_gears/ZSnackBar";
import SnackAlert from "./_gears/SnackAlert";
import { ActivityIndicator, Backdrop, XDiv } from "IZOX/_X";
import ZDialog from "./_gears/ZDialog";
import ZBackdrop from "./_gears/ZBackdrop";
import ZIdleTimer from "./_gears/ZIdleTImer";
import Listeners from "__SYSDefault/Listeners";
import SysAPI from "../API/SysAPI";
import ZSelectorOverlay from "./_gears/ZSelectorOverlay";
import ZRepeator from "./_gears/ZRepeater";
import { withRouter } from "react-router-dom/cjs/react-router-dom.min";
import ZModal from "./_gears/ZModal";
import { v1 } from "uuid";

/**
 * @augments {Component<Props, State>}
 */
class Overlay extends Component {

  static propTypes = {
    
  }

  static defaultProps = {

  }

  constructor(){
    super();
    this.state = {
      snackOpen: false,
      loadingOpen: false,
      dialogOpen: false,
      backdropOpen: false,
      modalOpen: false,
      selectorOverlayOpen: false,
      viewerOpen: false,
    };
  }

  componentDidMount(){
    this._setAllStates(() => {
      let {serverCheck, loggedCheck} = SysConfig.Settings;
      
      if(serverCheck){
        this.GetServerDetail(); 
      }
      if(loggedCheck){
        this.CheckExistLoggin();
      }
      _.map(StartUpFunc, (o, i) => {
        o();
      });
    });

    RegFunc.Register("Loading", this.Loading);
    RegFunc.Register("OpenSnack", this.OpenSnack);
    RegFunc.Register("CloseSnack", this.CloseSnack);
    RegFunc.Register("OpenDialog", this.OpenDialog);
    RegFunc.Register("CloseDialog", this.CloseDialog);
    RegFunc.Register("SetDialogLoading", this.SetDialogLoading);
    RegFunc.Register("OpenBackdrop", this.OpenBackdrop);
    RegFunc.Register("CloseBackdrop", this.CloseBackdrop);
    RegFunc.Register("OpenModal", this.OpenModal);
    RegFunc.Register("CloseModal", this.CloseModal);
    RegFunc.Register("OpenSelectorOverlay", this.OpenSelectorOverlay);
    RegFunc.Register("CloseSelectorOverlay", this.CloseSelectorOverlay);
    RegFunc.Register("OpenViewer", this.OpenViewer);
    RegFunc.Register("CloseViewer", this.CloseViewer);

    window.addEventListener("resize", this._resize);
  }

  _resize = () => {
    GState.setInnerWidth(window.innerWidth);
  }

  componentWillUnmount() {
    if(this.timeout) clearTimeout(this.timeout);
    window.removeEventListener("resize", this._resize);
    this.setState = (state, callback) => {
      return;
    };
  }

  _setAllStates = (callback) => {
    this.setState((state, props) => ({
      ...props,
    }), callback);
  }

  Loading = (tf) => {
    this.setState({
      loadingOpen: tf
    });
  }

  OpenSnack = (props) => {
    this.setState({
      snackOpen: true,
      snackProps: props
    });
  }

  CloseSnack = () => {
    this.setState({
      snackOpen: false,
      snackProps: null
    });
  }

  SetDialogLoading = (tf) => {
    let {dialogProps} = this.state;
    if(dialogProps){
      dialogProps.isLoading = tf;
    }
    this.setState({
      dialogProps
    });
  }

  OpenDialog = (props) => {
    this.setState({
      dialogOpen: true,
      dialogProps: props,
      dialogKey: v1()
    });
  }

  CloseDialog = () => {
    this.setState({
      dialogOpen: false,
      dialogProps: null
    });
  }

  OpenBackdrop = (props) => {
    this.setState({
      backdropOpen: true,
      backdropProps: props,
      backdropKey: v1()
    });
  }

  CloseBackdrop = () => {
    this.setState({
      backdropOpen: false,
      backdropProps: null
    });
  }

  OpenModal = (props) => {
    this.setState({
      modalOpen: true,
      modalProps: props,
      modalKey: v1()
    });
  }

  CloseModal = () => {
    this.setState({
      modalOpen: false,
      modalProps: null
    });
  }

  OpenSelectorOverlay = (props) => {
    this.setState({
      selectorOverlayOpen: true,
      selectorOverlayProps: props,
      selectorOverlayKey: v1()
    });
  }

  CloseSelectorOverlay = () => {
    this.setState({
      selectorOverlayOpen: false,
      selectorOverlayProps: null
    });
  }

  OpenViewer = (props) => {
    this.setState({
      viewerOpen: true,
      viewerProps: props,
      viewerKey: v1()
    });
  }

  CloseViewer = () => {
    this.setState({
      viewerOpen: false,
      viewerProps: null
    });
  }

  CheckExistLoggin = async () => {
    if(GState.user){
      let res = await ReqX.SendBE("/CommonAPI/Env/CheckJWT", {}, null, null);
      let {Success} = res;
      if(Success){
        GState.setLogged(true);
      }
    }
  }

  _onIdle = async () => {
    await Listeners.onIdle();
  }

  _onAwake = async () => {
    await Listeners.onAwake();
  }

  _onRefresh = async () => {
    await Listeners.onRefresh();
  }

  GetServerDetail = async () => {
    let res = await ReqX.SendBE(SysAPI.EnvInfoAPI, {}, null, 
      () => {
        GFunc.Alert({
          EN: "Internal Server Error.",
          TC: "伺服器內部錯誤"
        }, "error");
      },
      () => {
        let {location} = this.props;
        let isPublic = LogicX.isOneOf(location?.pathname, SysConfig.Project.publicPath);
        let isTest = location?.pathname?.startsWith("/Test/");
  
        GFunc.Alert({
          EN: "Cannot connect to server.",
          TC: "不能連接伺服器"
        }, "error");
        if(!isPublic && !isTest){
          this.AutoLogout();
        }
      }, false, true);

    let {Success, payload} = res;
    if(Success){
      GState.setServer(payload);
    }
  }

  AutoLogout = () => {
    if(this.timeout) clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      console.error("[x] Unauothorized :: Redirecting to Login");
      GState.clearUser();
      NavX.Goto(this.props.history, SysConfig.Project.LogoutPage);
    }, 1000);
  }

  renderSnackBar(){
    let {snackOpen, snackProps} = this.state;
    let {message, severity, duration} = snackProps ?? {};
    return (
      <ZSnackBar show={snackOpen} onClose={this.CloseSnack} 
        autoHideDuration={duration ?? SysConfig.Snackbar.duration[severity] ?? 3000}>
        <SnackAlert 
          message={message}
          severity={severity} 
          onClose={this.CloseSnack}/>
      </ZSnackBar>
    );
  }

  renderLoading(){
    let {loadingOpen} = this.state;
    return (
      <Backdrop open={loadingOpen}>
        <ActivityIndicator loading/> 
      </Backdrop>
    );
  }

  renderDialog(){
    let {dialogOpen, dialogProps} = this.state;
    return (
      <Backdrop open={dialogOpen}>
        <ZDialog content={dialogProps}/>
      </Backdrop>
    );
  }

  renderBackdrop(){
    let {backdropOpen, backdropProps, backdropKey} = this.state;
    return (
      <Backdrop open={backdropOpen} noBG={backdropProps?.noBG} key={backdropKey}
        clickThrough={backdropProps?.closeOutside}
        onClickBackground={(e) => {
          e.stopPropagation();
          if(backdropProps?.closeOutside) {
            backdropProps?.onClose?.();
            this.CloseBackdrop();
          }
        }}>
        <ZBackdrop content={backdropProps}/>
      </Backdrop>
    );
  }

  renderSelectorOverlay(){
    let {selectorOverlayOpen, selectorOverlayProps, selectorOverlayKey} = this.state;
    return (
      <Backdrop open={selectorOverlayOpen} noBG={selectorOverlayProps?.noBG} key={selectorOverlayKey}
        zIndex={2000} clickThrough noBlur={true}
        onClickBackground={(e) => {
          e.stopPropagation();
          if(selectorOverlayProps?.closeOutside) {
            selectorOverlayProps?.onClose?.();
            this.CloseSelectorOverlay();
          }
        }}>
        <ZSelectorOverlay content={selectorOverlayProps}/>
      </Backdrop>
    );
  }

  renderModal(){
    let {modalOpen, modalProps, modalKey} = this.state;
    return (
      <Backdrop open={modalOpen} noBG={modalProps?.noBG} key={modalKey}
        clickThrough={modalProps?.closeOutside} zIndex={1001}
        onClickBackground={(e) => {
          e.stopPropagation();
          if(modalProps?.closeOutside) {
            modalProps.onClose?.();
            this.CloseModal();
          }
        }}>
        <ZModal content={modalProps}/>
      </Backdrop>
    );
  }

  renderViewer(){
    let {viewerOpen, viewerProps, viewerKey} = this.state;
    let {closeOnMaskClick, onClose, images, props} = viewerProps ?? {};
    return (
      <Viewer
        key={viewerKey}
        visible={viewerOpen}
        onMaskClick={() => {
          if(closeOnMaskClick){
            this.CloseViewer();
            onClose?.(); 
          }
        }}
        onClose={() => { 
          this.CloseViewer(); 
          onClose?.(); 
        }}
        images={images ?? []}
        {...props}
        />
    );
  }

  render(){
    let {children} = this.props;
    return (
      <XDiv className="izox-overlay-main" fullWidth fullHeight>
        <ZIdleTimer onIdle={this._onIdle} onAwake={this._onAwake}/>
        <ZRepeator onRefresh={this._onRefresh}/>
        <XDiv className="izox-overlay-children" fullWidth fullHeight>
          {children}
        </XDiv>
        {this.renderSnackBar()}
        {this.renderBackdrop()}
        {this.renderModal()}
        {this.renderSelectorOverlay()}
        {this.renderDialog()}
        {this.renderLoading()}
        {this.renderViewer()}
      </XDiv>
    );
  }

}

export default observer(withRouter(Overlay));
